module.exports = __webpack_public_path__ + "img/adminonly_icon_active.cb370bb5.svg";